/*
 * humo-one-click.js — Humo Commerce
 * «Купить в один клик» (snippets/humo-one-click.liquid, стили — humo-one-click.css).
 *
 * Модалок на странице может быть две:
 *  • на странице товара — #humo-one-click-<id товара>; цену и id варианта в её data-атрибутах
 *    при смене варианта обновляет humo-product.js;
 *  • общая для карточек товаров — #humo-one-click-card (выводит humo-header). Кнопка карточки
 *    (snippets/humo-product-card.liquid) при открытии подставляет в неё свой товар
 *    из data-атрибутов. Модалка переносится в <body>, чтобы не зависеть от закреплённой шапки.
 * Кнопка находит свою модалку по aria-controls. Клики ловим на document: карточки,
 * подгруженные фильтрами и «Показать ещё» (humo-collection.js), работают без повторной привязки.
 *
 * Открытие/закрытие (кнопка, ✕, клик по фону, Esc), ловушка фокуса,
 * маска телефона +998 XX XXX XX XX, проверка полей и отправка заявки
 * POST JSON на app proxy (адрес — в настройках секции, data-endpoint).
 * Успех — только HTTP 200/201. Заявка всегда на 1 шт.
 *
 * Кнопка «Оформить рассрочку» (snippets/humo-installment.liquid) открывает модалку страницы
 * товара в режиме рассрочки: другой заголовок, строка с условиями под ценой,
 * в заявку добавляется installment — строка с условиями, как в модалке. Условия берутся
 * из калькулятора в момент открытия, суммы считаются на 1 шт. (как и вся заявка).
 *
 * «Узнать цену» — товары с метаполем custom.price_on_request = true (цену не показываем,
 * купить нельзя). Кнопка с data-price-request (карточка товара или страница товара) открывает
 * ту же модалку: заголовок «Узнать цену», «Цена по запросу» вместо суммы, в заявку добавляется
 * price_request: true. Отладка: ?humo_debug=1 в адресе включает логи [FIX:price-request].
 */
(function () {
  'use strict';

  // Скрипт подключают и humo-main-product, и humo-header — второй экземпляр ничего не делает
  if (window.humoOneClickLoaded) return;
  window.humoOneClickLoaded = true;

  var PHONE_DIGITS = 12;   // 998 + 9 цифр номера
  var PHONE_PREFIX = '+998 ';
  var NBSP = ' ';

  var DEBUG = /[?&]humo_debug=1(&|$)/.test(window.location.search);

  function debug(message, data) {
    if (DEBUG) console.log('[FIX:price-request] ' + message, data || '');
  }

  var installmentWidget = document.querySelector('.js-humo-installment');
  var controllers = {};

  /* ---------- Рассрочка ---------- */
  // Как humo-format-sum.liquid: целое число, разряды через неразрывный пробел
  function formatSum(value) {
    return String(Math.round(value)).replace(/\B(?=(\d{3})+(?!\d))/g, NBSP);
  }

  // Текущий выбор в калькуляторе: активный провайдер и активный срок в видимой группе
  function readInstallment() {
    if (!installmentWidget) return null;
    var provider = installmentWidget.querySelector('.humo-installment__provider--active');
    var groups = installmentWidget.querySelectorAll('.js-humo-installment-terms');
    var term = null;
    for (var i = 0; i < groups.length; i++) {
      if (!groups[i].hidden) term = groups[i].querySelector('.humo-installment__term--active');
    }
    if (!provider || !term) {
      console.error('[humo-one-click] installment selection not found', { provider: !!provider, term: !!term });
      return null;
    }
    var monthsLabel = term.querySelector('.humo-installment__term-months');
    var unit = installmentWidget.querySelector('.humo-installment__monthly-unit');
    return {
      provider: provider.getAttribute('data-provider-name') || '',
      months: Number(term.getAttribute('data-months')) || 1,
      rate: Number(term.getAttribute('data-rate')) || 0,
      monthsLabel: monthsLabel ? monthsLabel.textContent.trim() : '',
      unit: unit ? unit.textContent.trim() : ''
    };
  }

  // Товар из data-атрибутов кнопки карточки
  function readProduct(button) {
    return {
      variantId: button.getAttribute('data-variant-id') || '',
      title: button.getAttribute('data-product-title') || '',
      price: button.getAttribute('data-product-price') || '0',
      priceText: button.getAttribute('data-price-text') || '',
      sku: button.getAttribute('data-sku') || '',
      image: button.getAttribute('data-image') || ''
    };
  }

  /* ---------- Маска телефона (порт fmtPhone из дизайна) ---------- */
  function formatPhone(raw) {
    var d = String(raw).replace(/\D/g, '');
    if (d.indexOf('998') !== 0) d = '998' + d.replace(/^998?/, '');
    d = d.slice(0, PHONE_DIGITS);
    var parts = [d.slice(0, 3), d.slice(3, 5), d.slice(5, 8), d.slice(8, 10), d.slice(10, 12)];
    var filled = [];
    for (var j = 0; j < parts.length; j++) {
      if (parts[j]) filled.push(parts[j]);
    }
    return '+' + filled.join(' ');
  }

  function escapeHtml(text) {
    var div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  function isVisible(node) {
    return !!(node.offsetWidth || node.offsetHeight || node.getClientRects().length);
  }

  /* ---------- Одна модалка ---------- */
  function createController(modal) {
    var el = {
      card: modal.querySelector('.humo-modal__card'),
      heading: modal.querySelector('.js-humo-one-click-heading'),
      subtitle: modal.querySelector('.js-humo-one-click-subtitle'),
      title: modal.querySelector('.js-humo-one-click-title'),
      price: modal.querySelector('.js-humo-one-click-price'),
      sku: modal.querySelector('.js-humo-one-click-sku'),
      skuWrap: modal.querySelector('.js-humo-one-click-sku-wrap'),
      image: modal.querySelector('.js-humo-one-click-image'),
      installment: modal.querySelector('.js-humo-one-click-installment'),
      form: modal.querySelector('.js-humo-one-click-form'),
      formState: modal.querySelector('.js-humo-one-click-form-state'),
      success: modal.querySelector('.js-humo-one-click-success'),
      thanks: modal.querySelector('.js-humo-one-click-thanks'),
      name: modal.querySelector('.js-humo-one-click-name'),
      phone: modal.querySelector('.js-humo-one-click-phone'),
      trap: modal.querySelector('.js-humo-one-click-trap'),
      error: modal.querySelector('.js-humo-one-click-error'),
      submit: modal.querySelector('.js-humo-one-click-submit')
    };
    if (!el.card || !el.form || !el.name || !el.phone || !el.submit) {
      console.error('[humo-one-click] modal markup is incomplete', modal.id);
      return null;
    }

    var strings = {
      required: modal.getAttribute('data-error-required') || '',
      submit: modal.getAttribute('data-submit-text') || el.submit.textContent,
      sending: modal.getAttribute('data-sending-text') || el.submit.textContent,
      successHtml: modal.getAttribute('data-success-html') || '',
      sendError: modal.getAttribute('data-error-text') || '',
      subtitle: el.subtitle ? el.subtitle.textContent : '',
      priceSubtitle: modal.getAttribute('data-subtitle-price-request') || '',
      priceRequestText: modal.getAttribute('data-price-request-text') || ''
    };

    var sending = false;
    var submitted = false;  // была попытка отправки — с этого момента подсвечиваем ошибки
    var opener = null;      // кнопка, открывшая модалку: на неё вернём фокус
    var installment = null; // выбранные условия рассрочки или null для «Купить в один клик»
    var priceRequest = false; // режим «Узнать цену»: цены нет, в заявку уходит price_request

    // Общая модалка карточек — в <body>: внутри закреплённой шапки её перекрывал бы контекст наложения
    if (modal.hasAttribute('data-humo-portal') && modal.parentNode !== document.body) {
      document.body.appendChild(modal);
    }

    /* Товар из карточки: data-атрибуты модалки (их читает отправка) и видимая сводка */
    function setProduct(item) {
      modal.setAttribute('data-variant-id', item.variantId);
      modal.setAttribute('data-product-price', item.price);
      modal.setAttribute('data-product-title', item.title);
      if (el.title) el.title.textContent = item.title;
      if (el.price) el.price.textContent = item.priceText;
      if (el.sku) el.sku.textContent = item.sku;
      if (el.skuWrap) el.skuWrap.hidden = !item.sku;
      if (el.image) {
        el.image.removeAttribute('srcset');
        if (item.image) {
          el.image.setAttribute('src', item.image);
          el.image.hidden = false;
        } else {
          el.image.removeAttribute('src');
          el.image.hidden = true;
        }
      }
    }

    // Ежемесячный платёж на 1 шт. по текущей цене варианта, в минимальных единицах
    function installmentMonthly() {
      var price = Number(modal.getAttribute('data-product-price')) || 0;
      return price * (1 + installment.rate / 100) / installment.months;
    }

    // Условия одной строкой — её видит покупатель в модалке и она же уходит в заявку,
    // например «Alif nasiya · 12 мес · +38% · 146 625 сум / мес»
    function installmentText() {
      var monthly = formatSum(installmentMonthly() / 100) + ' ' + installment.unit;
      var parts = [installment.provider, installment.monthsLabel, '+' + installment.rate + '%', monthly];
      return parts.filter(Boolean).join(' · ');
    }

    function setMode(selection, isPriceRequest) {
      installment = isPriceRequest ? null : selection;
      priceRequest = !!isPriceRequest;
      var titleAttr = 'data-title-one-click';
      if (priceRequest) titleAttr = 'data-title-price-request';
      else if (installment) titleAttr = 'data-title-installment';
      var title = modal.getAttribute(titleAttr);
      if (el.heading && title) el.heading.textContent = title;
      if (el.subtitle) {
        el.subtitle.textContent = priceRequest && strings.priceSubtitle ? strings.priceSubtitle : strings.subtitle;
      }
      // Цены у такого товара нет (в Shopify стоит 0) — вместо суммы «Цена по запросу»
      if (priceRequest && el.price && strings.priceRequestText) el.price.textContent = strings.priceRequestText;
      if (!el.installment) return;
      if (!installment) {
        el.installment.hidden = true;
        el.installment.textContent = '';
        return;
      }
      el.installment.textContent = installmentText();
      el.installment.hidden = false;
    }

    /* ---------- Открытие / закрытие ---------- */
    function focusable() {
      return el.card.querySelectorAll('button:not([disabled]), input:not([disabled]):not([tabindex="-1"]), a[href]');
    }

    function open(source, selection, item, isPriceRequest) {
      // После успешной заявки при повторном открытии — снова чистая форма
      if (!el.success.hidden) resetForm();
      // Другой товар — ошибки прошлой попытки к нему не относятся
      if (item) {
        if (modal.getAttribute('data-variant-id') !== item.variantId) clearErrors();
        setProduct(item);
      }
      opener = source;
      setMode(selection || null, isPriceRequest);
      if (priceRequest) {
        debug('open', { modal: modal.id, variantId: modal.getAttribute('data-variant-id'), title: modal.getAttribute('data-product-title') });
      }

      modal.hidden = false;
      document.documentElement.classList.add('humo-modal-open');
      document.addEventListener('keydown', onKeydown);
      el.name.focus();
    }

    function close() {
      if (modal.hidden) return;
      modal.hidden = true;
      document.documentElement.classList.remove('humo-modal-open');
      document.removeEventListener('keydown', onKeydown);
      if (opener && document.contains(opener)) opener.focus();
    }

    function onKeydown(e) {
      if (e.key === 'Escape') {
        close();
        return;
      }
      if (e.key !== 'Tab') return;

      // Ловушка фокуса: Tab не уходит из модалки
      var items = [];
      var all = focusable();
      for (var i = 0; i < all.length; i++) {
        if (isVisible(all[i])) items.push(all[i]);
      }
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        last.focus();
        e.preventDefault();
      } else if (!e.shiftKey && document.activeElement === last) {
        first.focus();
        e.preventDefault();
      }
    }

    var closers = modal.querySelectorAll('.js-humo-one-click-close');
    for (var i = 0; i < closers.length; i++) {
      closers[i].addEventListener('click', close);
    }

    /* ---------- Телефон ---------- */
    function phoneDigits() {
      return el.phone.value.replace(/\D/g, '');
    }

    el.phone.addEventListener('focus', function () {
      if (!el.phone.value) el.phone.value = PHONE_PREFIX;
    });

    el.phone.addEventListener('input', function () {
      el.phone.value = el.phone.value.length < PHONE_PREFIX.length ? PHONE_PREFIX : formatPhone(el.phone.value);
      if (submitted) validate();
    });

    el.phone.addEventListener('blur', function () {
      if (el.phone.value.trim() === '+998') el.phone.value = '';
    });

    el.name.addEventListener('input', function () {
      if (submitted) validate();
    });

    /* ---------- Проверка и ошибки ---------- */
    function showError(text) {
      if (!el.error) return;
      el.error.textContent = text || '';
      el.error.hidden = !text;
    }

    function validate() {
      var nameOk = el.name.value.trim() !== '';
      var phoneOk = phoneDigits().length === PHONE_DIGITS;

      el.name.classList.toggle('humo-field__input--invalid', !nameOk);
      el.name.setAttribute('aria-invalid', nameOk ? 'false' : 'true');
      el.phone.classList.toggle('humo-field__input--invalid', !phoneOk);
      el.phone.setAttribute('aria-invalid', phoneOk ? 'false' : 'true');

      showError(nameOk && phoneOk ? '' : strings.required);
      return nameOk && phoneOk;
    }

    function clearErrors() {
      submitted = false;
      el.name.classList.remove('humo-field__input--invalid');
      el.phone.classList.remove('humo-field__input--invalid');
      el.name.removeAttribute('aria-invalid');
      el.phone.removeAttribute('aria-invalid');
      showError('');
    }

    function setSending(value) {
      sending = value;
      el.submit.disabled = value;
      el.submit.textContent = value ? strings.sending : strings.submit;
    }

    function showSuccess(name, phone) {
      el.thanks.innerHTML = strings.successHtml
        .replace('__NAME__', escapeHtml(name))
        .replace('__PHONE__', escapeHtml(phone));
      el.formState.hidden = true;
      el.success.hidden = false;
      var continueBtn = el.success.querySelector('button');
      if (continueBtn) continueBtn.focus();
    }

    function resetForm() {
      el.form.reset();
      clearErrors();
      setSending(false);
      el.success.hidden = true;
      el.formState.hidden = false;
    }

    /* ---------- Отправка ---------- */
    el.form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (sending) return;

      submitted = true;
      if (!validate()) {
        (el.name.value.trim() ? el.phone : el.name).focus();
        return;
      }

      var name = el.name.value.trim();
      var phone = el.phone.value.trim();

      // Заполненная ловушка — это бот: делаем вид, что всё хорошо, но ничего не отправляем
      if (el.trap && el.trap.value) {
        showSuccess(name, phone);
        return;
      }

      if (!window.fetch) {
        showError(strings.sendError);
        return;
      }

      setSending(true);
      showError('');

      var payload = {
        customer_name: name,
        customer_phone: phone,                                         // в маске, например "+998 90 123 45 67"
        product_price: Number(modal.getAttribute('data-product-price')), // как в Shopify, в минимальных единицах
        product_title: modal.getAttribute('data-product-title'),
        variant_id: String(modal.getAttribute('data-variant-id'))
      };
      // Только для «Оформить рассрочку»; у «Купить в один клик» заявка прежняя
      if (installment) {
        payload.installment = installmentText(); // строка, суммы на 1 шт.
      }
      // Только для «Узнать цену»: product_price в такой заявке 0 — цена в Shopify не указана
      if (priceRequest) {
        payload.price_request = true;
        debug('submit', payload);
      }

      fetch(modal.getAttribute('data-endpoint'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (response) {
        if (response.status === 200 || response.status === 201) {
          if (priceRequest) debug('submit ok', response.status);
          setSending(false);
          showSuccess(name, phone);
          return;
        }
        console.error('[humo-one-click] submit failed', response.status);
        setSending(false);
        showError(strings.sendError);
      }).catch(function (error) {
        console.error('[humo-one-click] submit failed', error);
        setSending(false);
        showError(strings.sendError);
      });
    });

    return { open: open };
  }

  /* ---------- Запуск ---------- */
  var modals = document.querySelectorAll('.js-humo-one-click');
  for (var m = 0; m < modals.length; m++) {
    var controller = modals[m].id ? createController(modals[m]) : null;
    if (controller) controllers[modals[m].id] = controller;
  }

  document.addEventListener('click', function (e) {
    var button = e.target.closest ? e.target.closest('.js-humo-one-click-open, .js-humo-installment-open') : null;
    if (!button || button.disabled) return;
    var controller = controllers[button.getAttribute('aria-controls')];
    // Модалки нет (выключена в настройках): кнопка карточки — обычная ссылка на страницу товара
    if (!controller) return;
    e.preventDefault();

    if (button.classList.contains('js-humo-installment-open')) {
      var selection = readInstallment();
      if (!selection) return; // калькулятор без выбора — нечего оформлять (ошибка уже в консоли)
      controller.open(button, selection, null);
      return;
    }
    controller.open(
      button,
      null,
      button.hasAttribute('data-variant-id') ? readProduct(button) : null,
      button.hasAttribute('data-price-request')
    );
  });
})();
